import { PlainButton } from 'components/Button'
import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color, fontSize } from 'utils'

import Restriction from './Restriction'

const P = styled.p`
  font-weight: 500;
  font-size: 1rem;
  line-height: 150%;
  margin: 0;
`
const A = styled.a`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  text-decoration: none;
`

const Button = styled(PlainButton)`
  color: ${color('blue500')};
  background: ${color('dark900')};
  border: 1px solid ${color('dark500')};
  font-size: ${fontSize('sm')};
  border-radius: 8px;
  text-decoration: none !important;
`

const EUSanctions = ({ children }) => (
  <Restriction>
    <>
      <P>{children}</P>
      <A
        href='https://ec.europa.eu/commission/presscorner/detail/en/ip_22_2332'
        target='_blank'
        rel='noopener noreferrer'
      >
        <Button size='md'>
          <I18n data={messages.learn_more} />
        </Button>
      </A>
    </>
  </Restriction>
)

export default EUSanctions
